<template>
<div class="card">
    <div class="card-header">Close Out Transaction</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="38"/>
        
        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
              <b-col>
                <b-alert show>Staffing has completed the vacancy portion of this request.</b-alert>
              </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="38" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.selectedCandidateName"
                               :v="$v.request.selectedCandidateName"
                               label="Selected Candidate Name"
                               tip=""
                               slug="candidateName"/>
              </b-col>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.selectedCandidateEmail"
                               :v="$v.request.selectedCandidateEmail"
                               label="Selected Candidate Email"
                               tip=""
                               slug="candidateEmail"/>
              </b-col>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.selectedCandidateEmployeeId"
                               :v="$v.request.selectedCandidateEmployeeId"
                               label="Selected Candidate Employee ID"
                               tip=""
                               slug="candidateEmpId"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.selectedCandidateAddress"
                               :v="$v.request.selectedCandidateAddress"
                               label="Selected Candidate Address"
                               tip=""
                               slug="candidateAddress"/>
              </b-col>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.selectedCandidatePhone"
                               :v="$v.request.selectedCandidatePhone"
                               label="Selected Candidate Phone"
                               tip=""
                               slug="candidatePhone"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" lg="4">
                <BaseTextOutput label="Final Classification" :value="request.audit.auditFinalClassification ? request.audit.auditFinalClassification : 'not provided'"/>
              </b-col>

              <b-col cols="12" lg="4">
                <BaseTextOutput label="Final Class Option" :value="request.audit.auditFinalClassOption ? request.audit.auditFinalClassOption : 'not provided'"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" lg="4">
                <BaseDateInput v-model="request.effectiveStartDate"
                               :v="$v.request.effectiveStartDate"
                               label="Effective Start Date"
                               slug="start-date"/>
              </b-col>
              <b-col cols="12" lg="4">
                <BaseSelector v-model="request.flsaStatusValue"
                              :v="$v.request.flsaStatusValue"
                              label="FLSA Status"
                              slug="flsaStatus"
                              :options=flsaStatusOptions
                              tip="" />
              </b-col>
              <b-col cols="12" lg="4">
                <BaseSelector v-model="request.bargainingUnit"
                              :v="$v.request.bargainingUnit"
                              label="Bargaining Unit"
                              slug="bargainingUnit"
                              :options=bargainingUnitOptions
                              tip="" />
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.step"
                               :v="$v.request.step"
                               slug="step"
                               label="Step"/>
              </b-col>
              <b-col cols="12" lg="4">
                <BaseMoneyInput v-model="request.rate"
                                :v="$v.request.rate"
                                slug="rate"
                                label="Rate"/>
              </b-col>
              <b-col cols="12" lg="4">
                <BaseTextInput v-model="request.probationaryPeriodLength"
                                :v="$v.request.probationaryPeriodLength"
                                slug="probationaryPeriodLength"
                                label="Probationary Period Length"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-row>
                  <b-col cols="4">
                    <BaseMultiCheckboxInput v-model="payrollActions"
                                            :v="$v.payrollActions"
                                            slug="payroll-actions"
                                            :options="payrollOptions"
                                            label="Payroll Actions"/>
                  </b-col>
                  <b-col cols="4">
                    <BaseTextInput v-model="request.leaveCredit"
                                   :v="$v.request.leaveCredit"
                                   slug="leave-credit"
                                   label="Leave Credit"/>
                  </b-col>
                  <b-col cols="4">
                    <BaseSelector v-model="request.rehireTimePeriod"
                                  :v="$v.request.rehireTimePeriod"
                                  slug="rehire-time-period"
                                  :options="rehireTimePeriodOptions"
                                  label="Rehire Time Period"/>
                  </b-col>

                </b-row>
                <b-row>
                  <b-col cols="5">
                    <BaseDateInput v-model="request.backpayDate"
                                   :v="$v.request.backpayDate"
                                   label="Backpay Date"
                                   slug="backpay-date"/>
                  </b-col>
                  <b-col cols="5">
                    <BaseDateInput v-model="request.reallocationEffectiveDate"
                                   :v="$v.request.reallocationEffectiveDate"
                                   label="Reallocation Effective Date"
                                   slug="reallocation-effective-date"/>
                  </b-col>


                </b-row>
                <b-row>
                  <b-col>
                    <BaseParagraphInput v-model="request.payrollComments"
                                        :v="$v.request.payrollComments"
                                        slug="payroll-comments"
                                        label="Payroll Comments"/>

                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table hover small show-empty
                         responsive="true"
                         :fields="leaveCommentFields"
                         :items="request.leaveComments"
                         :busy="false">
                  <template v-slot:no-data>
                    No Request Returned Comments Found.
                  </template>
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <template slot="empty" slot-scope="scope">
                    No Request Returned Comments Found.
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col>
                <BaseTextOutput :value="request.positionNumber"
                                label="PCN"/>
              </b-col>
              <b-col>
                <BaseTextOutput :value="request.division"
                                label="Division Name"/>
              </b-col>
              <b-col>
                <BaseTextOutput :value="request.departmentId"
                                label="Department ID"/>
              </b-col>
              <b-col>
                <BaseTextOutput :value="request.unitName"
                                label="Department Name"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <BaseTextOutput :value="getBargainingUnitText(request.bargainingUnit)"
                                label="Bargaining Unit"/>
              </b-col>
            </b-row>
            <hr/>

            <b-row>
              <b-col>
                <BaseTextOutput label="Appointment Type"
                                :value="request.appointmentValue.description"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Classified or Unclassified"
                                :value="request.positionClassificationValue.description"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Employment Condition"
                                :value="request.positionScheduleValue.description"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Position Location"
                                :value="request.positionLocation"/>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="3">
                <BaseTextOutput label="Type of Hire"
                                :value="request.hiringAction"/>
              </b-col>
              <b-col cols="3">
                <BaseTextOutput label="Leave Credit"
                                :value="request.leaveCredit"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Rehire Time Period"
                                :value="request.rehireTimePeriod"/>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col>
                <BaseTextOutput label="Supervisor Name"
                                :value="request.supervisor.name"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Supervisor Email"
                                :value="request.supervisor.email"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Supervisor Phone #"
                                :value="request.supervisor.phoneNbr"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Supervisor PCN"
                                :value="request.supervisor.pcn"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <BaseTextOutput label="Supervisor Department"
                                :value="request.supervisor.unitName"/>
              </b-col>
              <b-col cols="9">
                <BaseTextOutput label="Supervisor Department ID"
                                :value="request.supervisor.departmentId"/>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col cols="3">
                <BaseTextOutput label="Finance Information"/>
              </b-col>
              <b-col cols="3">
                <BaseTextOutput label="Needs Financial Management Review?"
                                :value="request.financeRequiresReview"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table-simple hover small caption-top responsive>
                  <b-thead>
                    <b-tr>
                      <b-th>Percent</b-th>
                      <b-th>Fund</b-th>
                      <b-th>Fin Dept ID</b-th>
                      <b-th>Approp ID</b-th>
                      <b-th>SW Cost</b-th>
                      <b-th>Sub Acct</b-th>
                      <b-th>Agcy Cost 1</b-th>
                      <b-th>Agcy Cost 2</b-th>
                      <b-th>Project</b-th>
                      <b-th>Activity</b-th>
                      <b-th>Source</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="(item, index) in request.funding" :key="index">
                      <b-td>{{item.fundingPercent}}</b-td>
                      <b-td>{{item.fundId}}</b-td>
                      <b-td>{{item.divisionId}}</b-td>
                      <b-td>{{item.appropriationId}}</b-td>
                      <b-td>{{item.swCost}}</b-td>
                      <b-td>{{item.subAccount}}</b-td>
                      <b-td>{{item.agcyCost1}}</b-td>
                      <b-td>{{item.agcyCost2}}</b-td>
                      <b-td>{{item.project}}</b-td>
                      <b-td>{{item.activity}}</b-td>
                      <b-td>{{item.sourceType}}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <hr/>
            <b-row>
              <b-col cols="3">
                <BaseTextOutput label="Offered Comments"
                                :value="request.offerComments"/>
              </b-col>
              <b-col cols="3">
                <BaseTextOutput label="Internal Comments"
                                :value="request.assignmentComments"/>
              </b-col>
              <b-col>
                <BaseTextOutput label="Offer Other Comments"
                                :value="request.offerOtherText"/>
              </b-col>
            </b-row>
            <hr/>
            <b-row v-if="request.returnPreviousLifecycleComments">
              <b-col>
                <BaseTextOutput :value="request.returnPreviousLifecycleComments"
                                label="Reasons Why This Request Was Returned"/>
              </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                    <b-button type="submit" variant="primary">Complete HR Transaction Close Out</b-button>
                    <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
                  <b-button type="button" variant="outline-danger" v-b-modal.modal-return-previous-lifecycle>Return to Staffing Specialist</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
  <b-modal id="modal-return-previous-lifecycle" hide-header hide-footer @hidden="close">
    <h2>Return To Previous Lifecycle</h2>
    <hr/>
    <form ref="form" @submit.prevent="onReturnToPriorLifecycle()">
      <BaseParagraphInput v-model="returnPreviousLifecycleComments"
                          :v="$v.returnPreviousLifecycleComments"
                          slug="returnPreviousLifecycleComments"
                          :required="$v.returnPreviousLifecycleComments.$params.required ? true : false"
                          label="Reason for returning to the previous lifecycle"/>
      <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
      <b-button type="submit" variant="primary" :disabled="$v.returnPreviousLifecycleComments.$invalid">Submit</b-button>
    </form>
  </b-modal>
</div>

</template>

<script>
import axios from "axios"
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  decimal,
  numeric,
  minValue,
  maxValue,
  requiredUnless,
  integer
} from 'vuelidate/lib/validators'
import _ from "lodash"
import { commonOptions } from '@/mixins/commonOptions.js'
import maxDate from "@/validators/maxDate";
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import { tableFields } from '@/mixins/tableFields.js'

export default {
    components: {
      LifecycleCheckList
    },

    mixins: [
       commonOptions,
       tableFields
    ],

    props: {
        request: Object
    },

    data() {
        return {
            saveOnly: false,
            payrollActions: [],
            returnPreviousLifecycleComments: null,
            checklistComplete: false,
        }
    },

     validations() {
        return {
            checklistComplete: { checked: value => value === true },
            request: {
              selectedCandidateEmail: { maxLength: maxLength(75) },
              selectedCandidateName: { maxLength: maxLength(75) },
              selectedCandidateEmployeeId: { maxLength: maxLength(75) },
              selectedCandidateAddress: { required: false, maxLength: maxLength(75) },
              selectedCandidatePhone: { required: false, maxLength: maxLength(75) },
              flsaStatusValue: {},
              bargainingUnit: {},
              effectiveStartDate: { required: false },
              step: { maxLength: maxLength(3) },
              rate: { decimal },
              probationaryPeriodLength: { required: false, maxLength: maxLength(20) },
              leaveCredit: {required: false, integer},
              rehireTimePeriod:{required: requiredIf(function (){
                if(this.request.hiringAction){
                  return this.request.hiringAction.toLowerCase().search(/re-?hire/) > -1
                }
                else{
                  return false
                }
                })},
              backpayDate: {
                required: false,
                maxDate: maxDate(new Date((new Date()).valueOf() - 1000*60*60*24))
              },
              reallocationEffectiveDate:{
                required: requiredIf(function (){
                  return _.includes(['03'], this.request.requestTypeValue.code)
                }), maxDate: maxDate(new Date((new Date()).valueOf() - 1000*60*60*24))},
              payrollComments: {required: false, maxLength: maxLength(4000)},
            },
            payrollActions: {required: false},
            returnPreviousLifecycleComments: {required: false, maxLength: maxLength(4000)},
        }
     },

    computed: {
    },
    created() {
      if(this.request.payrollActionsString){
        this.payrollActions = this.request.payrollActionsString.split(",")
      }
    },
    
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        save() {
          this.saveOnly = true
          this.onSubmit()
          this.saveOnly = false
        },

        onSubmit() {
          if (!this.saveOnly) {
            this.$refs.checklist.emitCheckListStatus()
            this.$v.$touch();
            if (this.$v.$invalid) {
              this.$nextTick(() => {
                document.getElementById('form-container').scrollIntoView()
              })
              return
            }
          }

            let payload = {
                requestId: this.request.id,
                saveOnly: this.saveOnly,

                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,

                selectedCandidatePhone: this.request.selectedCandidatePhone,
                selectedCandidateAddress: this.request.selectedCandidateAddress,

                audit: this.request.audit,
                effectiveStartDate: this.request.effectiveStartDate,
                flsaStatusValue: this.request.flsaStatusValue,
                bargainingUnit: this.request.bargainingUnit,

                step: this.request.step,
                rate: this.request.rate,
                probationaryPeriodLength: this.request.probationaryPeriodLength,

                payrollActionsString: this.payrollActions.join(','),

                leaveCredit: this.request.leaveCredit,

                rehireTimePeriod: this.request.rehireTimePeriod,
                backpayDate: this.request.backpayDate,
                reallocationEffectiveDate: this.request.reallocationEffectiveDate,

                payrollComments: this.request.payrollComments,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/transactions/closeout/complete`, payload)
                .then(response => {
                  this.showRootToast("Closeout Transaction", "Success", "success")
                  this.$router.push('/home')
                })

        },
        close() {
          this.$bvModal.hide("modal-return-previous-lifecycle")
          this.returnPreviousLifecycleComments=null
        },
        onReturnToPriorLifecycle(){
          let payload = {
            id: this.request.id,
            comment: this.returnPreviousLifecycleComments
          }
          console.log('Sending the request to go back now with this message: '+this.returnPreviousLifecycleComments)

          axios.post(`${process.env.VUE_APP_API_BASE_URL}/transactions/closeout/return`, payload)
              .then(response => {
                this.showRootToast("HRM Request Has Been Sent to Staffing Specialist", "Success", "success")
                this.$router.push('/home')
              })
        },

        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        getBargainingUnitText(bargainingUnitCode){
            return this.bargainingUnitOptions.find(code => code.value === bargainingUnitCode).text
        }
    }
}
</script>